export enum TranslationChange {
  ADD = 'add',
  EDIT = 'edit',
  REMOVE = 'remove',
}
